import React from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import authServices from '../../Services/authServices';
import { toast } from 'react-toastify';

export const ResetPassword = () => {
    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            admin_password: '',
            confirm_password:''
        },
        validationSchema: Yup.object({
            admin_password: Yup.string().min(8, 'Must be 8 characters or more').required('Required'),
            confirm_password: Yup.string()
                .min(8, 'Must be 8 characters or more')
                .required('Required').when("admin_password", {
                    is: val => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf(
                        [Yup.ref("admin_password")],
                        "Password don't match"
                    )
                })
        }),

        onSubmit: (values) => {
            let srcParam = new URLSearchParams(history.location.search).values()
            let resData = []
            for (const values of srcParam) {
            resData.push(values)
            }
            let postData = {admin_password:values.admin_password, first_token: resData[0], second_token: resData[1], t: resData[2]}
            authServices.reset_password(postData).then(res => {
                if (res.status) {
                history.push('/login')
                toast.success(res.data.message)
                } else {
                    toast.error(res.message)
                }
            }).catch((err) => {
                console.log(err,'err')
            })
        },
    });

    return (
        <div className="authentication-bg">
            <div className="account-pages w-100 pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div>
                                <div className="card">
                                    <a href="/" className="mt-4 d-block auth-logo">
                                        <img src="/admin/assets/images/logo_dark.svg" alt="" height={50} className="logo logo-dark" />
                                        <img src="/admin/assets/images/logo-light.png" alt="" height={22} className="logo logo-light" />
                                    </a>
                                    <div className="card-body">
                                        <div className="text-center">
                                            <h5 className="text-primary">Reset Password</h5>
                                            {/* <p className="text-muted">Reset Password with Minible.</p> */}
                                        </div>
                                        <div className="p-2 mt-4">
                                            <div className="alert alert-success text-center mb-4" role="alert">
                                                Enter New Password
                                            </div>
                                            <form onSubmit={(e) => formik.handleSubmit(e)}>
                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="newpassword">New Password</label>
                                                    <input type="password" id="newpassword" placeholder="Enter New Password" 
                                                    className={'form-control' + (formik.touched.admin_password ? !formik.errors.admin_password ? ' is-valid' : ' is-invalid' : '')}
                                                    {...formik.getFieldProps('admin_password')}
                                                    />
                                                    {formik.touched.admin_password && formik.errors.admin_password ? (
                                                    <div className="text-danger">{formik.errors.admin_password}</div>
                                                ) : null}
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="confirmpassword">New Password</label>
                                                    <input type="password" id="confirmpassword" placeholder="Enter Confirm Password" 
                                                    className={'form-control' + (formik.touched.confirm_password ? !formik.errors.confirm_password ? ' is-valid' : ' is-invalid' : '')}
                                                    {...formik.getFieldProps('confirm_password')}
                                                    />
                                                     {formik.touched.confirm_password && formik.errors.confirm_password ? (
                                                    <div className="text-danger">{formik.errors.confirm_password}</div>
                                                ) : null}
                                                </div>
                                                <div className="mt-3 text-end">
                                                    <button type='submit' className="btn btn-primary w-sm waves-effect waves-light" >Reset</button>
                                                </div>
                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Remember It ? <a onClick={() => history.push('/login')} className="fw-medium text-primary pointer"> Signin </a></p>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                    {/* end row */}
                </div>
                {/* end container */}
            </div>
            {/* JAVASCRIPT */}
        </div>
    )
}
